import { useSelector } from 'react-redux';

import { Features } from '@copilot/data/responses/interface';
import { useFeatureToggle } from '../../feature';
import { OrganizationMemberSelectors } from '@copilot/common/store/selectors/organizationMember';
import { isNil } from 'lodash';

/**
 * Callback function returned when ChatGPT is not enabled
 */
export function handleChatGptFeatureFlagOff() {
    return Promise.reject(new Error('The ChatGPT Feature is off'));
}

/**
 * Hook determining if the ChatGPT feature is enabled & the user is not CS.
 */
export function useChatGptFeature() {
    const isChatGptFeatureEnabled = useFeatureToggle(Features.ChatGPTFeature);
    const impersonatingMember = useSelector(OrganizationMemberSelectors.getAdminMember);
    /// CS should not see the chatGpt feature when impersonating
    return {
        isChatGptFeatureEnabled: isChatGptFeatureEnabled && isNil(impersonatingMember),
        handleChatGptFeatureFlagOff,
    };
}
